<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      lock-scroll
      close-on-popstate
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell-group>
        <van-cell
          :title="$t('D016','性别')"
          title-class="van-field__label"
          required
        >
          <van-radio
            v-model="sex"
            slot="right-icon"
            name="M"
          >
            {{ $t('D018','男') }}
          </van-radio>
          <van-radio
            v-model="sex"
            slot="right-icon"
            name="F"
            style="margin-left: 20px;"
          >
            {{ $t('D019','女') }}
          </van-radio>
        </van-cell>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'EditSex',
  mixins: [mixin],
  data() {
    return {
      sex: ''
    }
  },
  created () {
    this.sex = this.empInfo.sex || 'M'
  },
  methods: {
    complie () {
      this.empInfo.sex = this.sex
      this.save()
    }
  }
}
</script>